// Display-only glossary. Keep the saved Master text intact for audit and later C-end projections.
export function readableDecisionReason(value: string): string {
  return value
    .replace(/\bfast_alignment\b/gi, '与快速初筛的方向关系')
    .replace(/\bNOT_APPLICABLE\b/g, '不适用')
    .replace(/\bTREND_CONTINUATION\b/g, '趋势延续')
    .replace(/\bBEARISH\b/g, '偏空')
    .replace(/\bBULLISH\b/g, '偏多')
    .replace(/\bNEUTRAL\b/g, '方向不明')
    .replace(/\bUNKNOWN\b/g, '尚不明确')
    .replace(/\bbreakout_low\b/gi, '前期低点')
    .replace(/\bEMA(\d+)\b/gi, (_, periods: string) => `${periods}周期均价线`)
    .replace(/\bMACD柱?/gi, '趋势动能指标')
    .replace(/\bATR\d*\b/gi, '近期平均波动幅度')
    .replace(/\bpips?\b/gi, '点')
    .replace(/\bFast\b/g, '快速初筛')
    .replace(/\bBUY\b/g, '买入')
    .replace(/\bSELL\b/g, '卖出')
    .replace(/\bHOLD\b/g, '继续观察');
}
